//

//import React, {ChangeEvent, useState, useEffect} from "react";
import React,{useState, useReducer} from "react";
import './quickacces.scss';
import {MIPALinksobj} from '../../Entity/Linkobj';
import LinkItem from "./LinkItem";
import { Helper } from "../../Utils/Helper";

import NewLink from "./newlink";
import { Language } from "../../Utils/Language";

interface Props {
  fnGetLinks;
  fnUpdateLink;
  CacheLinks;
  AllLinks;
  Culture;
  fnGetPrev;
}

const LinkList: React.FC<Props> = (props) => {
    //const [notelist, setNoteList] = useState<Array<stickynoteobj>>(props.Notes);
    const [showentryform, setShowEntryForm] = useState<boolean>(false);
    const initialState = {
        Links:props.AllLinks
      }
    const [linkDataitem, setLinkDataItem] = useState<MIPALinksobj>(null);
    //linkitem:MIPALinksobj;
    
   
    const LinkReducer = (prevState, action) => {
        switch(action.type){
          case 'ADD_LINK':
            const newLink = {
              
                Links:[...prevState.Links, action.payload]
            }
            props.CacheLinks(newLink.Links);
            return newLink;
            case 'Update_LINK':
                let updatedlist=prevState.Links.filter((l)=>{return l.ID!=action.payload.ID});
                updatedlist.push(action.payload);
                const AfterupdateLink = {                   
                    Links:updatedlist
                    };
                    props.CacheLinks(AfterupdateLink.Links);
                    return AfterupdateLink;
            case 'Delete_LINK':
                let newlist=prevState.Links.filter((l)=>{return l.ID!=action.payload.ID});
                const AfterDeleteLink = {                   
                    Links:newlist
                    }
                    props.CacheLinks(AfterDeleteLink.Links);
                return AfterDeleteLink;
                case 'Load_FromWeb':
                    const newLinks = {
                        Links:action.payload
                      }
                      props.CacheLinks(action.payload);
                      return newLinks;
                
          default:
          return prevState;
        }
      }
     
    const [linkState, dispatch] = useReducer(LinkReducer,initialState)
    
    const UpdateList=(action,link)=>{
        
        let fordelete=false;
        if(action=='Delete_LINK'){
            fordelete=true;
            dispatch({ type:action, payload:link});
            props.fnUpdateLink(link,fordelete);
        }else{
            setLinkDataItem(link);
            setShowEntryForm(true);
        }
        //linkitem.LastUpdate=new Date();
        //props.fnUpdateLink(link,fordelete);
    }
    const SaveLinkInfo=()=>{
        linkDataitem.LastUpdate=new Date();
        if(linkDataitem.ID=='0'){
            linkDataitem.ID=Helper.newguid();
            dispatch({ type:'ADD_LINK', payload:linkDataitem});
        }else{
            dispatch({ type:'Update_LINK', payload:linkDataitem});
        }
        
        props.fnUpdateLink(linkDataitem,false);
        setShowEntryForm(false);
    }
    const [calledfromWeb, setCalledFromWeb] = useState<boolean>(false);
    if(calledfromWeb==false && linkState.Links.length==0){
        setCalledFromWeb(true);
        props.fnGetLinks((successres)=>{
            if(successres && successres.data && successres.data.IsSuccess){
                dispatch({ type:'Load_FromWeb', payload:successres.data.data})
            }
           })
    }
    
    let linkblock=[];
    let linklist=linkState.Links;
    Helper.SortList(linklist,'Priority',true,false);
    linklist.forEach((link,index)=>{
        linkblock.push(<LinkItem link={link} fnUpdateLink={UpdateList} key={link.ID} fnGetPrev={props.fnGetPrev} ></LinkItem>);
    });

    //let marginval=window.window.innerWidth<500 || window.innerHeight<500?"-45px":"-91px";
    return (
        <div className="linklistcontainer" >
            <span className="newlinkaction linkbutton" onClick={()=>{
                 setLinkDataItem({
                    ID: '0',
                    Description:'',
                    DisplayName:'',
                    Priority:0,
                    Thumb:'',
                    LastUpdate:new Date(),
                    URL:'',
                    color:'#fff'
                  })  ;
                setShowEntryForm(true);}}>
                    <i  className="ms-Icon ms-Icon--AddOnlineMeeting"></i>
                {Language.GetLanguageValue(props.Culture,'addlink')}
            </span>
            
            <div>
            {linkblock.length>0? linkblock:(<div className="emptymessageblock">Click on Add link action to creata a new link.</div>)}
            
            </div>
            {showentryform?(
                <NewLink Link={linkDataitem} UpdateLink={SaveLinkInfo} closeMethod={()=>{setShowEntryForm(false)}} ></NewLink>

            ):null}
        </div>
       
    )
};

export default LinkList;